<!--
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-07 15:08:31
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-04-08 10:30:20
 * @FilePath: \knowledge-graph\src\views\Login\login.vue
 * @Description: 登录
-->
<template>
  <div class="com-login-container">
    <div class="com-login-container-left">
      <img src="@/assets/login/login-bg.png" alt="">
    </div>
    <div class="com-login-container-right">
      <h2>登录知识图谱研阅系统</h2>
      <p>账号登录</p>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/phone.png" alt="">
        <input type="text" placeholder="请输入登录手机号" />
      </div>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/password.png" alt="">
        <input type="text" placeholder="请输入密码" />
      </div>
      <div class="com-login-container-right-form-link">
        <span @click.stop="$emit('jump', 'regist')">没有账号？立即注册</span>
        <span @click.stop="$emit('jump', 'forget')">忘记密码？</span>
      </div>
      <div class="com-login-container-right-form-btn">登录</div>
      <div class="com-login-container-right-form-agree">
        <div class="com-login-container-right-form-agree-checkbox" :class="{ checked }" @click.stop="checked = !checked"></div>
        <label for="agree">我已阅读并同意<a>《用户协议》</a>和<a>《隐私政策》</a></label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoginIndex',
  data () {
    return {
      checked: false
    }
  }
}
</script>
